import {
  AppBar,
  Box,
  Button,
  Dialog,
  Paper,
  DialogContent,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Grid,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  SsidChart as DownloadECGIcon,
  SignalCellularAlt as DownloadParamsIcon,
} from "@mui/icons-material";
import { useGetPatientReports, useGetReportById } from "../useReportQueries";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { useEffect, useRef, useState } from "react";
import { useGetPatientById } from "../../PatientComponents";
import CanvasJSReact from "@canvasjs/react-charts";
import { getPressureLayout } from "./reportUtils/pressureReport";
import {
  prettify,
  renderEUDate,
  renderEUDateTime,
  renderDateUTC,
  convertServerToLocalDatetime,
} from "../../../utils/utils";

function PressureReport({ report_id, patient_id, closeModal }) {
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  // === web service queries/mutations ===
  const reportQuery = useGetPatientReports(patient_id, 3, {
    page: 1,
    per_page: 20,
  });
  const reportInfo = useGetReportById(report_id);
  const patientQuery = useGetPatientById(patient_id);

  // === report display ===
  const [layout, setLayout] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // parse csv
    if (!loaded && reportQuery.isSuccess) {
      let measures = reportQuery.data.reports;
      let datapointsPmax = [];
      let datapointsPmin = [];
      let datapointsHR = [];

      // only get last 20 measurements
      if (measures.length > 20) {
        measures = measures.slice(0, 20);
      }

      // prendo le misurazioni di pressioni/hr + data
      measures.forEach((report, index) => {
        if (report.data.Pmax !== null && report.data.Pmax !== undefined) {
          datapointsPmax.push({
            // x: report.date,
            x: report.data.Date,
            y: eval(report.data.Pmax),
          });

          datapointsPmin.push({
            // x: report.date,
            x: report.data.Date,
            y: eval(report.data.Pmin),
          });

          datapointsHR.push({
            // x: report.date,
            x: report.data.Date,
            y: eval(report.data.HR),
          });
        }
      });

      // genero il report
      const layout = getPressureLayout(
        datapointsPmax,
        datapointsPmin,
        datapointsHR,
      );

      setLayout(layout);

      setLoaded(true);
    }
  }, [reportQuery.status]);

  return (
    <>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeModal}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent>
        {reportQuery.isLoading || reportInfo.isLoading || !loaded ? (
          <LoadingPaper />
        ) : reportQuery.isError || reportInfo.isError ? (
          <LoadingError error={reportQuery.error} />
        ) : (
          reportInfo.isSuccess && (
            <Stack spacing={2} direction={"column"}>
              <Paper sx={{ padding: "10px" }}>
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ float: "left" }}>
                    <Typography fontWeight={"bold"} variant="h5">
                      Misurazione Pressione
                    </Typography>
                  </Box>
                </Box>

                <Grid container>
                  <Grid item xs={6}>
                    <Typography>
                      Assitito:{" "}
                      {patientQuery.isLoading
                        ? ""
                        : `${patientQuery.data.first_name} ${patientQuery.data.last_name}`}
                    </Typography>
                    <Typography>
                      Dispositivo: {prettify(reportInfo.data.origin)}
                    </Typography>
                    <Typography>
                      Data misurazione:
                      {renderEUDateTime(
                        convertServerToLocalDatetime(reportInfo.data.data.Date),
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>
                      Pressione massima: {reportInfo.data.data.Pmax}
                    </Typography>
                    <Typography>
                      Pressione minima: {reportInfo.data.data.Pmin}
                    </Typography>
                    <Typography>
                      Frequenza Cardiaca: {reportInfo.data.data.HR}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
              {reportQuery.isLoading ? (
                <LoadingPaper />
              ) : reportQuery.isError ? (
                <LoadingError error={reportQuery.error} />
              ) : (
                <Paper sx={{ padding: "10px" }}>
                  {layout !== undefined && loaded && (
                    <CanvasJSChart
                      key={layout?.title?.text ?? "pressure-layout"}
                      options={layout}
                    />
                  )}
                </Paper>
              )}
            </Stack>
          )
        )}
      </DialogContent>
    </>
  );
}

export default PressureReport;
